<template>
  <b-container>
    <b-row>
      <b-col> </b-col>
    </b-row>
    <div class="application-view">
      <div class="reg-form-box">
        <div class="reg-form-body">
          <b-container class="bv-example-row">
            <b-row>
              <b-col cols="12">
                <b-container class="bv-example-row">
                  <h5 class="reg-form-title text-primary">Personal Details</h5>
                  <table class="profile-table table-3x" style="margin-left: 0">
                    <tbody>
                      <tr>
                        <td>
                          <span class="bold">Applicant Name:</span>
                          {{ personalDetails.FullName }}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="bold">Aadhar Id:</span>
                          {{ personalDetails.AdharNo }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-container>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
    </div>
    <div class="application-view">
      <b-row>
        <b-col md="6">
          <b-form @submit="onSubmit" @reset="onReset">
            <div class="form-row">
              <b-col class="py-0">
                <b-form-group
                  id="iGpTnr"
                  label-cols="4"
                  label="Loan Tenure (Months)*"
                  label-size="sm"
                  label-for="inpTenure"
                >
                  <b-form-input
                    id="inpTenure"
                    type="number"
                    min="1"
                    max="60"
                    v-model="form.LoanTenure"
                    size="sm"
                    required
                    placeholder="Tenure"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </div>
            <div class="form-row">
              <b-col class="py-0">
                <b-form-group
                  id="iGpRoi"
                  label-cols="4"
                  label="Rate of Interest % *"
                  label-size="sm"
                  label-for="inpRoi"
                >
                  <b-form-input
                    id="inpRoi"
                    type="number"
                    min="1.0"
                    max="20.0"
                    step="0.05"
                    v-model="form.ROI"
                    size="sm"
                    required
                    placeholder="Rate of Interest %"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </div>
            <div class="form-row">
              <b-col class="py-0 my-0">
                <b-form-group
                  id="exampleInputGroup2"
                  label-cols="5"
                  label="Disbursement Amount Rs.*"
                  label-size="sm"
                  label-for="inpAmount"
                >
                  <b-form-input
                    id="inpAmount"
                    type="number"
                    min="10000"
                    max="1500000"
                    v-model="form.DisburmentAmount"
                    size="sm"
                    required
                    placeholder="Loan Amount Rs."
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </div>
            <div class="form-row">
              <b-col class="py-0">
              <b-form-group
                id="igrp1"
                label="EMI Start Date*"
                label-cols="4"
                label-size="sm"
              >
                <b-form-input
                  type="date"
                  placeholder="Start Date"
                  size="sm"
                  v-model="form.EmiStartDate"
                ></b-form-input>
              </b-form-group>
              </b-col>
            </div>
            <div class="form-row">
              <b-col class="py-0">
              <b-form-group
                id="igrp2"
                label="EMI End Date"
                label-cols="4"
                label-size="sm"
              >
                <b-form-input
                  type="date"
                  placeholder="End Date"
                  size="sm"
                  required
                  v-model="form.EmiEndDate"
                  disabled
                ></b-form-input>
              </b-form-group>
              </b-col>
            </div>
            <div class="form-row" v-if="1 == 2">
              <b-col class="py-0">
                <b-form-group
                  id="grpEmiDate"
                  label-cols="4"
                  label="Apply Changes From Date"
                  label-size="sm"
                  label-for="ipEmiDate"
                >
                  <b-select
                    id="ipEmiDate"
                    class="form-control"
                    value-field="EMIDate"
                    size="sm"
                    text-field="EMIDate"
                    :options="EMIDates"
                    v-model="form.EMIStartDate"
                  ></b-select>
                </b-form-group>
              </b-col>
            </div>
            <div class="form-row" v-if="1 == 2">
              <b-col class="py-0 my-0">
                <b-form-group
                  id="igBalanceAmt"
                  label-cols="3"
                  label="Balance Loan Amount Rs.*"
                  label-size="sm"
                  label-for="inpBAmount"
                >
                  <b-form-input
                    id="inpBAmount"
                    type="number"
                    min="100000"
                    max="1500000"
                    v-model="form.BalaneAmount"
                    size="sm"
                    required
                    placeholder="Balance Loan Amount Rs."
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </div>
            <div class="form-row" v-if="RoleType == 1">
              <b-col class="py-0 my-0">
                <b-form-group
                  id="grpRemarks"
                  label-cols="2"
                  label="Remarks"
                  label-size="sm"
                  label-for="ipRmk"
                >
                  <b-form-textarea
                    id="ipRemarks"
                    v-model="form.Remarks"
                    size="sm"
                    rows="2,"
                    max-rows="4"
                    placeholder="Remarks"
                  ></b-form-textarea>
                </b-form-group>
              </b-col>
            </div>
            <div class="form-row">
              <b-col class="md-6">
                <b-button
                  type="submit"
                  class="float-right"
                  variant="primary"
                  v-if="RoleType == 1"
                  >Submit</b-button
                >
                <b-button
                  type="reset"
                  class="float-right mx-3"
                  variant="danger"
                  v-if="RoleType == 1"
                  >Reset</b-button
                >
              </b-col>
            </div>
            <div class="form-row">
              <b-col>
                <Spinner
                  size="32"
                  message="Loading..."
                  v-if="isLoading"
                ></Spinner>
                <b-alert
                  :show="showDismissibleAlert"
                  dismissible
                  @dismissed="showDismissibleAlert = false"
                  :variant="variant"
                  >{{ alertText }}</b-alert
                >
              </b-col>
            </div>
          </b-form>
        </b-col>
        <b-col md="6">
          <b-table
            striped
            hover
            :items="logTbl"
            :fields="fields"
            head-variant="dark"
            style="font-size: 12px"
          >
          </b-table>
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>
<script>
import apis from "@/apis";
import DatePicker from "vue2-datepicker";
import Spinner from "vue-simple-spinner";
import Formatter from "@/Formatter.js";

export default {
  components: { Spinner, DatePicker },
  props: ["item"],
  watch: {
    // "form.DisburmentAmount"(newval){
    //   TotalDisbursementAmount = Number(LoanDetails) + Number(newval);
    // },
    "form.EmiStartDate"(newval) {
      if (this.form.LoanTenure > 0) {
        let dtl = new Date(newval);

        let n = this.form.LoanTenure - 1;
        dtl.setMonth(dtl.getMonth() + n);
        this.form.EmiEndDate = this.formatDate(dtl);
      }
    },
    "form.LoanTenure"(newval) {
      if (this.form.EmiStartDate != null) {
        let dtl = new Date(this.form.EmiStartDate);

        let n = newval - 1;
        dtl.setMonth(dtl.getMonth() + n);
        this.form.EmiEndDate = this.formatDate(dtl);
      }
    },
  },
  computed: {
    RoleType() {
      var userinfo = this.$store.getters.loggedUser;
      return userinfo.RoleID;
    },
  },
  data() {
    return {
      showDismissibleAlert: false,
      variant: "success",
      alertText: "",
      isLoading: false,
      logTbl:[],
      fields:[],
      form: {
        LoanDisbursementID: "00000000-0000-0000-0000-000000000000",
        LoanSanctionID: "",
        LoanTenure: 0,
        UpdatedBy: "",
        ROI: 0,
        DisbursalDate: null,
        EmiStartDate: null,
        EmiEndDate: null,
        VerifiedStatus: 0,
        TrancheNo: 0,
        SeparateTenure: false,
        DisburmentAmount: 0,
        EmiAmount: 0,
        HOApprovedAmount: 0,
        UploadDisburmentLetter: "",
        UploadBankStatement: "",
      },
      personalDetails: {
        UserID: null,
        FullName: null,
        AdharNo: "",
      },
    };
  },
  methods: {
    convertDateFormat(inDate) {
      return Formatter.convertDateFormat(inDate);
    },
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    format(value, event) {
      if (value) {
        return value.trim();
      }
    },
    onReset(evt) {
      evt.preventDefault();
      this.setDefaultValues();
    },
    setDefaultValues() {
      this.personalDetails.UserID = this.item.UserID;
      this.personalDetails.FullName = this.item.FullName;
      this.personalDetails.AdharNo = this.item.AdharNo;

      this.form.LoanDisbursementID = this.item.LoanDisbursementID;
      this.form.LoanSanctionID = this.item.LoanSanctionID;
      this.form.LoanTenure = this.item.LoanTenure;
      this.form.UpdatedBy = this.item.UserID;
      this.form.ROI = this.item.ROI;
      this.form.DisbursalDate = this.item.DisbursalDate;
      this.form.EmiStartDate = this.formatDate(this.item.EmiStartDate);
      this.form.EmiEndDate = this.formatDate(this.item.EmiEndDate);
      this.form.VerifiedStatus = 0;
      this.form.TrancheNo = this.item.TrancheNo;
      this.form.SeparateTenure = this.item.SeparateTenure;
      this.form.DisburmentAmount = this.item.DisburmentAmount;
      this.form.EmiAmount = this.item.EmiAmount;
      this.form.HOApprovedAmount = this.item.SanctionAmount;
      this.form.UploadDisburmentLetter = this.item.UploadDisburmentLetter;
      this.form.UploadAmortizationSchedule =
        this.item.UploadAmortizationSchedule;
    },
    async onSubmit(evt) {
      evt.preventDefault();
      // if (
      //   Number(this.LoanDetails.SanctionAmount) <
      //   Number(this.TotalDisbursementAmount) +
      //     Number(this.form.DisburmentAmount)
      // ) {
      //   this.alertText =
      //     "Total Disbursement can't be more than Approved value.";
      //   this.variant = "danger";
      //   this.showDismissibleAlert = true;
      //   return;
      // }
      this.showDismissibleAlert = false;
      this.isLoading = true;

      //this.form.UploadDisburmentLetter = response.message;
      var userinfo = this.$store.getters.loggedUser;
      this.form.UpdatedBy = userinfo.UserId;
      let sanctionForm = {
        LoanSactionID:this.form.LoanSanctionID,
        ROI:this.form.ROI,
        UserID: userinfo.UserId,
        LoanTenure:this.form.LoanTenure
      }

      let promiseS = apis.updateLoanSanction(sanctionForm);
      let promise = apis.saveDisbursement(this.form);

      promiseS.then((response) =>{
        console.log(response.status);
      });

      promise
        .then((response) => {
          if (response.status == 200) {
            this.form.LoanDisbursementID = response.body[0].LoanDisbursementID;
            // this.emiList = response.body;
            // this.totalRows = this.emiList.length;
            // this.LoanDetails.DisbursementAmount =
            //   Number(this.atStartDisbursementAmount) +
            //   Number(this.form.DisburmentAmount);
            this.alertText = "Data Saved Successfully";
            this.isSaved = true;
            this.variant = "success";
            this.showDismissibleAlert = true;
          } else {
            this.alertText = response.body;
            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch((err) => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },
  },
  mounted() {
    this.setDefaultValues();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/ClaimApproval/EditLoanDetails.vue